/* RESPONSIBLE TEAM: team-rd-services */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorEditScorecardAttributeSelectRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'monitor.edit-scorecard.attribute-select',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorEditScorecardAttributeSelectRoute);
